// Dev note: use AuthContext or authHooks for scopes, gates, and limits
// https://git.hubteam.com/HubSpot/automation-ui-core/blob/2dbaf7e046a05188637bcee991838a8cea70ba1a/automation-ui-core/static/js/context/AuthContext.tsx
// https://git.hubteam.com/HubSpot/automation-ui-core/blob/2dbaf7e046a05188637bcee991838a8cea70ba1a/automation-ui-core/static/js/hooks/authHooks.ts

import { createSelector } from 'reselect';
const getUserRoot = state => state.auth.user;
const getPortalRoot = state => state.auth.portal;
export const getHubSpotUserId = createSelector([getUserRoot], userRoot => userRoot.user_id);
export const getPortalId = createSelector([getPortalRoot], portalRoot => portalRoot.portal_id);